import React, { Component } from 'react';
import { withFirebase } from '../../Firebase';
import { withRouter } from 'react-router-dom';
import PeerLine from '../../PeerLine/PeerLine';
import TeamLine from '../../TeamLine/TeamLine';
import CardCarousel from '../../Card/BasicCardCarousel';
import CreateCapsule from '../../Home/ButtonCreate';
import 'firebase/functions';
import * as firebase from 'firebase';
import { Fade, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LatestPolls from '../../Home/LatestPolls';


const INITIAL_STATE = {
  managerID: '',
  myAssignments: [],
  snackbarUpDownOpen : false,
  currentCapsuleId : '',
  action : null,
  needToRemoveIfUndo : false,
  loading : true,
  teamCapsules: [],
  peersCapsules: [],
  error: null,
  currentUserInfos : null,
};

const styles_loader = theme => ({
  root: {
      position: 'absolute',
      left : '50%',
      top : window.innerWidth > 768 ? '35vh' : '65vh'
  },
  button: {
      margin: theme.spacing.unit * 2,
  },
  progress: {
      color: '#0070A2',
  },
  placeholder: {
      position : 'relative',
      left : '-50%',
      height: 40,
  },
});

class PendingPage extends Component {

  render() {
    return (
      <PendingPageComponent />)
  }
}

class PendingPageComponentBase extends Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {

    document.body.style.background = '#F8F9FB';

    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

      if (currentUser === null) {
          return
      }

    let querySnapshotUsers = await this.props.firebase.db.collection('users').get()
    const currentUserInfos = querySnapshotUsers.docs
            .filter(user => user.id === currentUser.uid)
            .map(doc => doc.data())[0] || {manager : ''};
    const managerID = currentUserInfos.manager;
    let querySnapshotCapsulesPeers = await this.props.firebase.db.collection('capsules').where('managers','array-contains',managerID).get()
    let querySnapshotCapsulesTeam = await this.props.firebase.db.collection('capsules').where('managers','array-contains',currentUser.uid).get()
    
    let peersCapsules = [];
    let teamCapsules = [];

    for (const capsulePeer of querySnapshotCapsulesPeers.docs){
      const data = capsulePeer.data()
      const managers = data.managers;
      const status = data.status;
      if (status === 'pending'){
        if (managers.includes(managerID)){
          peersCapsules = peersCapsules.concat({
            id: capsulePeer.id,
            ...capsulePeer.data()
          });
        }
      }
    }

    for (const capsuleTeam of querySnapshotCapsulesTeam.docs){
      const data = capsuleTeam.data()
      const managers = data.managers;
      const status = data.status;
      if (status === 'pending'){
        if (managers.includes(currentUser.uid)){
          teamCapsules = teamCapsules.concat({
            id: capsuleTeam.id,
            ...capsuleTeam.data()
          });
        }
      }

    }

    this.setState({
      peersCapsules,
      teamCapsules,
      managerID,
      loading : false,
      currentUserInfos,
    });

    });
  }

  openSnackbar = () => {
    this.setState({ snackbarUpDownOpen: true });
  };

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarUpDownOpen: false, needToRemoveIfUndo : false });
  };

  upCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    const timestamp = Date.now();
    const {currentUserInfos} = this.state
    this.setState({ 
      currentCapsuleId : capsuleID,
      action : 'up',
      needToRemoveIfUndo : !managers.includes(this.state.managerID)})

    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.state.managerID)
    })
    let newHistoric = {date: timestamp, firstname: currentUserInfos.firstname, lastname: currentUserInfos.lastname, picture: currentUserInfos.image_url_profile, status: "up"}
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
    this.openSnackbar();

  }

  downCapsule = async (capsuleID) => {
    let querySnapshotCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get()
    let managers = querySnapshotCapsule.data().managers
    const timestamp = Date.now();
    const {currentUserInfos} = this.state
    this.setState({ 
      currentCapsuleId : capsuleID,
      action : 'down',
      needToRemoveIfUndo : !managers.includes(this.props.firebase.auth.currentUser.uid)
    })
    await this.props.firebase.db.collection('capsules').doc(capsuleID).update({
      managers: firebase.firestore.FieldValue.arrayUnion(this.props.firebase.auth.currentUser.uid)
    })
    let newHistoric = {date: timestamp, firstname: currentUserInfos.firstname, lastname: currentUserInfos.lastname, picture: currentUserInfos.image_url_profile, status: "down"}
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
    this.openSnackbar();
  }

  undoUpDown = async () => {
    const {action, currentCapsuleId, needToRemoveIfUndo} = this.state
    if (needToRemoveIfUndo){
      if (action === 'up') {
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.state.managerID)
        })
        this.closeSnackbar();
      }
      else {
        const currentCapsuleId = this.state.currentCapsuleId;
        await this.props.firebase.db.collection('capsules').doc(currentCapsuleId).update({
          managers: firebase.firestore.FieldValue.arrayRemove(this.props.firebase.auth.currentUser.uid)
        })
        this.closeSnackbar();
      }
    }
    this.closeSnackbar();
  }

  render() {
    const { classes } = this.props
    const loading = this.state.loading
    return (
      <div>
        <LatestPolls page={'pending'}/>
        <PeerLine/>
        <div className={classes.root}>
          <div className={classes.placeholder}>
            <Fade
              in={loading}
              unmountOnExit
            >
              <CircularProgress className={classes.progress} />
            </Fade>
          </div>
        </div>
        <Fade in={loading === false}>
          <div>
            <CardCarousel data={this.state.peersCapsules}
              direction={'down'}
              upCapsule={this.upCapsule}
              downCapsule={this.downCapsule}
              undo={this.undoUpDown}
              snackbarUpDownOpen={this.state.snackbarUpDownOpen}
              closeSnackbar={this.closeSnackbar}
              messageSnackBar={this.state.action === 'up' ? "Capsule remontée" : "Capsule descendue"} />
          </div>
        </Fade>
        <TeamLine />
        <Fade in={loading === false}>
          <div>
            <CardCarousel data={this.state.teamCapsules} 
              direction={'up'}
              upCapsule = {this.upCapsule}
              downCapsule = {this.downCapsule}
              undo = {this.undoUpDown}
              snackbarUpDownOpen = {this.state.snackbarUpDownOpen}
              closeSnackbar = {this.closeSnackbar}
              messageSnackBar = {this.state.action === 'up' ? "Capsule remontée" : "Capsule descendue"}/>
          </div>
        </Fade>
        <CreateCapsule/>
      </div>
    );
  }
}

PendingPageComponentBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

const PendingPageComponent = withRouter(withFirebase(withStyles(styles_loader)(PendingPageComponentBase)));

export default (PendingPage);
export { PendingPageComponent };